import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ApiCall } from '@shared/async-services/http/api-call.service';
import storageService from '@shared/storage/storageService';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  public resetForm: FormGroup;
  hide: boolean = false;
  hide1: boolean = false;
  showResetForm = false;
  emailFromUrl:any;
  errorMessage: any;
  selectedLanguage = "";
  public submitted = false;

  constructor(private fb: FormBuilder,
    private auth:ApiCall,
    private router:Router,
    private toastr:ToastrService,
    private activatedRoute: ActivatedRoute,
    public translate: TranslateService
    ) { }

    get f(){
      return this.resetForm.controls;
    }
     
  ngOnInit(): void {
    this.setLanguage();
    this.auth.validateResetToken(this.activatedRoute.snapshot.params.token).subscribe(
      (res: any) => {
        if(res.data != null){
          this.showResetForm = true;
          this.emailFromUrl=res.data.email;
        }else{
          this.errorMessage = res.message;
          this.showResetForm = false;
        }
      },
      (err: any) => {
        this.showResetForm = false;
        this.errorMessage = err.message;
        console.log("Something went wrong");
      }
    );
    this.resetForm = this.fb.group({
      newPassword: ["", [Validators.required,Validators.minLength(8),Validators.pattern("^(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=-_]).*$")]],
      confirmPassword: ["", [Validators.required,Validators.minLength(8),Validators.pattern("^(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=-_]).*$")]],   
    },{
      validator: ConfirmedValidator('newPassword', 'confirmPassword')
    });
  }

  setLanguage() {
    this.selectedLanguage = storageService.getItem("language");
    this.translate.use(this.selectedLanguage);
  }
  
  onReset(){
    this.submitted = true;
    if (!this.resetForm.valid) {
      return;
    }
    this.auth.resetPassword(this.resetForm.value.newPassword,this.emailFromUrl).subscribe(
      (res: any) => { 
        let message;
        this.translate.get(['RESET_PASSWORD_SUCCESS'])
        .subscribe(translations => {
          message = translations['RESET_PASSWORD_SUCCESS'];
      }); 
        this.toastr.success(message,'',{
          timeOut:3000
        });
        this.router.navigate(['/landing-page']);
      },
      (err: any) => {
        console.log("Something went wrong");
      }
    );
   
  }

}
function ConfirmedValidator(controlName: string, matchingControlName: string): any {
  return (formGroup: FormGroup) => {
    const control = formGroup.controls[controlName];
    const matchingControl = formGroup.controls[matchingControlName];
    if (matchingControl.errors && !matchingControl.errors.confirmedValidator) {
        return;
    }
    if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ confirmedValidator: true });
    } else {
        matchingControl.setErrors(null);
    }
}
}
